import { render } from "./redirect.vue?vue&type=template&id=20494e08&scoped=true"
import script from "./redirect.vue?vue&type=script&lang=js"
export * from "./redirect.vue?vue&type=script&lang=js"

import "./redirect.vue?vue&type=style&index=0&id=20494e08&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20494e08"]])

export default __exports__